import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

export function SlideNumber( Splide, Components ) {
	const { track } = Components.Elements;
  
	let elm;
  
	function mount() {
	  elm = document.createElement( 'span' );
	  elm.classList.add("numbers");
	  //track.parentElement.insertBefore( elm, track.nextSibling );

	  jQuery(elm).insertBefore('.mech .splide__arrow--next');
  
	  update();
	  Splide.on( 'move', update );
	}
  
	function update() {
	  elm.textContent = `${ Splide.index + 1 } of ${ Splide.length }`;
	}
  
	return {
	  mount,
	};
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var loading_icon = '<svg width="42" height="42" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="loading_icon" style="background: none;"><circle cx="50" cy="50" fill="none" stroke="#03417d" stroke-width="8" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(215.934 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>';

jQuery(window).on('load', function() {
	jQuery('html').removeClass('preload');
});

jQuery(document).ready(function() {

	var width = jQuery(window).width();

	function resiNav() {
		jQuery( ".menu" ).before( "<figure></figure>" );
		//jQuery('.sub-menu').prepend('<li class="current_parent"><p></p></li>');

		// var parents = jQuery('.menu-item-has-children');
		// for (var i = 0; i < parents.length; i++) {
		// 	var parentTitle = parents[i].children[0].text;
		// 	var previousParentTitle = parents[i].children[1].children[0].children[0];
		// 	previousParentTitle.innerText = parentTitle;
		// }

		jQuery('.menu-header .menu > .menu-item-has-children').click(function (e) {

			
			if (jQuery(e.target).parent().hasClass('menu')){
				if (e.target.tagName === 'LI'){
					jQuery(this).toggleClass('open');
					jQuery(this).find('> ul.sub-menu').toggleClass('open');
				}
				console.log(this);
			}

		});

		jQuery('.menu-header .menu > .menu-item-has-children > .sub-menu .menu-item-has-children').click(function (e) {

			
			if (e.target.tagName === 'LI'){
				jQuery(this).toggleClass('open');
				jQuery(this).find('> ul.sub-menu').toggleClass('open');
			}
		});

		jQuery('li.current_parent').click(function() {
			jQuery(this).parent().toggleClass('open');
		});

		jQuery('.resi_button, .resi_over, .menu-header figure').click(function() {
			jQuery('html').toggleClass('js-nav');
			jQuery('ul.sub-menu').removeClass('open')
		});

	}
	resiNav();

	jQuery('*[data-scroll]').click(function() {
		var target = jQuery(this).data('scroll');

		jQuery('html, body').animate({
			 scrollTop: jQuery(target).offset().top - 129
		}, 300);
	});

	// Remove error message form CF7 when input is clicked
	if (jQuery('.wpcf7').length > 0) {
		jQuery('.wpcf7 input, .wpcf7 teaxtarea, .wpcf7 select').click(function(){
			jQuery(this).next('.wpcf7-not-valid-tip').remove();
		});
	}

	if (WPURLS.ajaxurl) {

		// jQuery('form#user_popup_login').validate({
		// 	submitHandler: function(form) {

		// 		var redirect_url = jQuery('form#user_popup_login [name="_wp_http_referer"]').val();

		// 		jQuery.ajax({
		// 			type: 'POST',
		// 			dataType: 'json',
		// 			url: WPURLS.ajaxurl,
		// 			data: {
		// 				'action': 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
		// 				'username': jQuery('form#user_popup_login #username').val(),
		// 				'password': jQuery('form#user_popup_login #password').val(),
		// 				'security': jQuery('form#user_popup_login #security').val()
		// 			},
		// 			success: function(data){
		// 				// jQuery('form#login p.status').text(data.message);
		// 				if (data.loggedin == true){
		// 					document.location.href = redirect_url;
		// 				} else {
		// 					jQuery('form#user_popup_login input.required').addClass('error');
		// 					jQuery('#password').after('<label id="login-error" class="error">' + data.message + '</label>');
		// 					jQuery('form#user_popup_login input.required').on('keyup keydown blur', function() {
		// 						jQuery('form#user_popup_login input.required').removeClass('error');
		// 						jQuery('label#login-error').remove();
		// 					});
		// 				}
		// 			}
		// 		});

		// 	}
		// });

	}

	// if (jQuery('#pagepiling').length > 0){

	// 	jQuery('#pagepiling').pagepiling({
	// 		navigation: false,
	// 		onLeave: function(index, nextIndex, direction){
	// 			//after leaving section 2
	// 			if(nextIndex == 5 && direction =='down'){

	// 				setTimeout(() => {
	// 					jQuery('html').addClass('foot_scroll');
	// 				}, "1000");

	// 				//jQuery('#pagepiling').pagepiling.setAllowScrolling(false);
	// 				console.log('bottom');
	// 			} else {
	// 				jQuery('html').removeClass('foot_scroll');
	// 				//jQuery('#pagepiling').pagepiling.setAllowScrolling(true);
	// 				console.log('not bottom');
	// 				jQuery("html, body").animate({ scrollTop: "0px" }, 300);
	// 			}
	// 		}
	// 	});


	// 	jQuery('#pagepiling .down').click(function () {
	// 		jQuery('#pagepiling').pagepiling.moveSectionDown();
	// 	});

	// }

	// jQuery(window).scroll(function () {

	// 	var footOffset = jQuery('footer').offset().top - jQuery(window).scrollTop() - jQuery(window).height();

	// 	console.log(footOffset);


	// });


		jQuery('#pagepiling .down').click(function () {
			//jQuery('#pagepiling').pagepiling.moveSectionDown();

			if (jQuery(this).hasClass('last')) {
				jQuery('html, body').animate({
					scrollTop: jQuery('.footer').offset().top - 110
			   }, 300);
			} else {
				jQuery('html, body').animate({
					scrollTop: jQuery(this).parent().parent().next().offset().top - 110
			   }, 300);
			}



		});


	if (jQuery('.home_top.splide').length > 0){

		var home = new Splide( '.home_top.splide', {
			type: 'loop',
			mediaQuery: 'min',
			gap: 0,
			arrows: true,
			perPage: 1,
			pagination: true,
			autoplay: true,
			interval: 6000,
		} );
	
		home.mount();
	
	}

	if (jQuery('.mech.splide').length > 0){

		var mech = new Splide( '.mech.splide', {
			type: 'loop',
			mediaQuery: 'min',
			gap: 0,
			arrows: true,
			perPage: 1,
			pagination: false,
		} );
	
		mech.mount({SlideNumber});
	
	}

	if (jQuery('.related_studies__wrap.splide').length > 0){

		var related = new Splide( '.related_studies__wrap.splide', {
			type: 'loop',
			mediaQuery: 'min',
			gap: 20,
			arrows: true,
			perPage: 1,
			perMove: 1,
			pagination: false,
			breakpoints: {
				1100: {
				  perPage: 4,
				},
				800: {
				  perPage: 3,
				},
				480: {
				  perPage: 2,
				},
			},
		} );
	
		related.mount();
	
	}


	if (jQuery('.team--slider .splide').length > 0){

		var people = new Splide( '.team--slider .splide', {
			perPage: 4,
			perMove: 1,
			gap: 32,
			arrows: true,
			pagination: false,
			breakpoints: {
				1100: {
				  perPage: 3,
				},
				800: {
				  perPage: 2,
				},
				480: {
				  perPage: 1,
				},
			},
		} );
	
		people.mount();
	
	}


	if (jQuery('.main_slider.splide').length > 0){

		var main = new Splide( '.main_slider.splide', {
			type      : 'loop',
			rewind    : true,
			pagination: false,
			arrows    : true,
		} );
	
		

		
			var thumb = new Splide( '#thumbnail-carousel', {
				  fixedWidth: 130,
				  gap       : 5,
				  rewind    : true,
				  pagination: false,
				  isNavigation: true,
				  breakpoints : {
					600: {
					  fixedWidth : 60,
					  fixedHeight: 44,
					},
				  },
			} );

			main.sync( thumb );

			main.mount();

			thumb.mount();
		
	
	}


	jQuery('.team__single').click(function () {

		var desc = jQuery(this).attr('data-desc') || '';
		var email = jQuery(this).attr('data-email') || '';
		var phone = jQuery(this).attr('data-phone') || '';
		var mobile = jQuery(this).attr('data-mobile') || '';
		var name = jQuery(this).find('.team__single__name').text();
		var title = jQuery(this).find('.team__single__title').text();
		var img = jQuery(this).find('> img').attr('src');
		var $email = jQuery('.l_box_team__email');
		var $tel = jQuery('.l_box_team__tel');
		var $mob = jQuery('.l_box_team__mob');
		var $content = jQuery('.l_box_team__content');

		jQuery('.l_box_team__image').attr('src', img);
		jQuery('.l_box_team__name').text(name);
		jQuery('.l_box_team__title').text(title);

		if ( email ) {
			$email.show().find('a').attr('href', 'mailto:' + email).text(email);
		} else {
			$email.hide().find('a').attr('href', '').text('');
		}

		if ( phone ) {
			$tel.show().find('span').text(phone);
		} else {
			$tel.hide().find('span').text('');
		}

		if ( mobile ) {
			$mob.show().find('span').text(mobile);
		} else {
			$mob.hide().find('span').text('');
		}

		if ( $content.length ) {
			if ( desc ) {
				var hasHtml = /<[a-z][\s\S]*>/i.test( desc );
				var contentHtml = hasHtml
					? desc
					: jQuery( '<div>' ).text( desc ).html().replace( /\n/g, '<br>' );
				$content.prop( 'hidden', false ).html( contentHtml );
			} else {
				$content.prop( 'hidden', true ).empty();
			}
		}

		jQuery('body').addClass('l_box_team--open');

	});

	jQuery('.l_box_team .close').click(function () {
		jQuery('body').removeClass('l_box_team--open');
	});

	jQuery('.prod_archive__filter__trig').click(function () {
		jQuery(this).parent().toggleClass('open');
	});

	// jQuery('.resources__list__item p').click(function () {
	// 	jQuery(this).parent().toggleClass('active');
	// });

	// jQuery(document).on("click",".resources__list__item p",function() {
	// 	jQuery(this).parent().toggleClass('active');
	// });


	document.addEventListener( 'wpcf7mailsent', function( event ) {
		console.log(event);
	}, false );

	// if ( jQuery('body').hasClass('blog') ) {
	// 	jQuery("#recent-sticky").stick_in_parent({offset_top: 40});
	// }

	jQuery('body').on('change', '.case_studies select', function (e) {
		jQuery(this).parent().parent().submit();
	});


	jQuery('body').on('change', '.category_select select', function (e) {
		var target = jQuery(this).find('option:selected').val();
		window.location.assign(target);
	});

	jQuery('body').on('change', '.filter_select_wrap select', function (e) {
		jQuery(this).parent().parent().submit();
	});


	function normaliseVariationString(str) {
		return (str || '').toLowerCase().replace(/[\s_]+/g, '-');
	}

	// "Pearl (non-stocked)" is stored as pearl-non-stocked, while the image is Pearl-Novello.
	function variationMatchLabel(str) {
		return normaliseVariationString((str || '').replace(/\s*\([^)]*\)/g, ' ')).replace(/^-+|-+$/g, '');
	}

	function sourceContainsLabel(source, label) {
		if (!source || !label) {
			return false;
		}

		var segments = source.split('-').filter(Boolean);
		var parts = label.split('-').filter(Boolean);

		if (!parts.length || parts.length > segments.length) {
			return false;
		}

		var i, p, matched;
		for (i = 0; i <= segments.length - parts.length; i++) {
			matched = true;
			for (p = 0; p < parts.length; p++) {
				if (segments[i + p] !== parts[p]) {
					matched = false;
					break;
				}
			}
			if (matched) {
				return true;
			}
		}

		return false;
	}

	function getImageFilename($img) {
		var src = $img.attr('src') || $img.attr('data-src') || $img.attr('data-large_image') || '';
		var filename = src.split('/').pop() || '';
		filename = filename.replace(/(-scaled)?-\d+x\d+(?=\.[a-z]+$)/i, '');
		filename = filename.replace(/\.[^.]+$/, '');
		return normaliseVariationString(filename);
	}

	function getVariationOptions() {
		var options = [];
		jQuery('.variations select option').each(function() {
			var value = jQuery(this).val();
			if (value) {
				options.push({
					value: value,
					text: normaliseVariationString(jQuery(this).text()),
					label: variationMatchLabel(jQuery(this).text())
				});
			}
		});
		options.sort(function(a, b) { return b.value.length - a.value.length; });
		return options;
	}

	function matchVariationFromImage($img) {
		var title = normaliseVariationString($img.attr('title'));
		var alt = normaliseVariationString($img.attr('alt'));
		var filename = getImageFilename($img);
		var sources = [title, alt, filename].filter(Boolean);
		var options = getVariationOptions();

		if (!options.length || !sources.length) {
			return null;
		}

		var i, j, opt, source;

		for (i = 0; i < options.length; i++) {
			opt = options[i];
			for (j = 0; j < sources.length; j++) {
				if (sources[j] === opt.value || sources[j] === opt.text) {
					return opt.value;
				}
			}
		}

		for (i = 0; i < options.length; i++) {
			opt = options[i];
			for (j = 0; j < sources.length; j++) {
				source = sources[j];
				if (source.indexOf(opt.value) !== -1 || (opt.text && source.indexOf(opt.text) !== -1)) {
					return opt.value;
				}
			}
		}

		for (i = 0; i < options.length; i++) {
			opt = options[i];
			if (opt.value.indexOf('-') !== -1) {
				continue;
			}
			for (j = 0; j < sources.length; j++) {
				var segments = sources[j].split(/[-\s]+/);
				for (var k = 0; k < segments.length; k++) {
					if (segments[k] === opt.value || segments[k] === opt.text) {
						return opt.value;
					}
				}
			}
		}

		var best = null;
		for (i = 0; i < options.length; i++) {
			opt = options[i];
			if (!opt.label) {
				continue;
			}
			for (j = 0; j < sources.length; j++) {
				if (!sourceContainsLabel(sources[j], opt.label)) {
					continue;
				}
				if (!best || opt.label.length > best.label.length || (opt.label.length === best.label.length && opt.value === opt.label && best.value !== best.label)) {
					best = opt;
				}
				break;
			}
		}

		return best ? best.value : null;
	}

	function syncVariationFromGalleryImage($img) {
		var value = matchVariationFromImage($img);
		if (value) {
			jQuery('.variations select').val(value).change();
		}
	}

	jQuery('.flex-control-thumbs').bxSlider({
		infiniteLoop: false,
		maxSlides: 6,
		minSlides: 3,
		moveSlides: 1,
		slideWidth: 80,
		touchEnabled: false,
		slideMargin: 7,
		pager: false,
		nextText: '<span class="nextslide"></span>',
		prevText: '<span class="prevslide"></span>'
	});

	jQuery('.woocommerce-product-gallery__wrapper').bxSlider({
		infiniteLoop: false,
		maxSlides: 1,
		minSlides: 1,
		moveSlides: 1,
		//slideWidth: 519,
		adaptiveHeight: true,
		//slideMargin: 0,
		wrapperClass: 'bx-wrapper bx-wrapper--gallery',
		pager: false,
		// nextText: '<span class="nextslide"></span>',
		// prevText: '<span class="prevslide"></span>',

		// Change variation option based on colour in slider
		onSlideAfter: function() {
			syncVariationFromGalleryImage(jQuery('.woocommerce-product-gallery__image[aria-hidden=false] img'));
		}
	});


	jQuery('.flex-control-thumbs li').mouseup( function() {
		setTimeout(function(){
			syncVariationFromGalleryImage(jQuery('.woocommerce-product-gallery__image.flex-active-slide img'));
		}, 500); 
	});



	jQuery('body').on('click', '.quant-wrap .quant-inc', function() {
		var el = jQuery(this).parent().find('.qty');
		var old = el.val();
		console.log(old);
		var old = parseFloat(old) + 1;


		if (jQuery('body').hasClass('single-product')){
			jQuery('.quant-wrap .qty').val(old);
		} else {
			jQuery(this).parent().find('.qty').val(old);
		}

		jQuery('body').find('.button.update').removeAttr('disabled');
	});

	jQuery('body').on('click', '.quant-wrap .quant-dec', function() {
		var el = jQuery(this).parent().find('.qty');
		var old = el.val();
		console.log(old);
		var old = parseFloat(old) - 1;
		if (old > 0){
			if (jQuery('body').hasClass('single-product')){
				jQuery('.quant-wrap .qty').val(old);
			} else {
				jQuery(this).parent().find('.qty').val(old);
			}
			jQuery('body').find('.button.update').removeAttr('disabled');
		}
	});


	// validate form on load
	jQuery('.checkout .input-text').each( function() {
		if(jQuery(this).val()) {
			jQuery(this).closest('.form-row').addClass('woocommerce-validated');
		}
	});


	jQuery('.woocommerce-billing-fields #billing-different').change(function () {
		jQuery('.woocommerce-billing-fields .billing-hidden').toggleClass('hidden');
	});


	jQuery('.shipping_address input').on('blur', function () {

		var data = jQuery(this).val();
		var shippingId = jQuery(this).attr('name');
		var billingId = shippingId.replace('shipping_', 'billing_');

		console.log(data);
		console.log(billingId);

		jQuery('body').find('.billing-hidden input#' + billingId).val(data);

	});

	jQuery('.shipping_address select#shipping_country').on('change', function () {
		var data = jQuery(this).val();
		var shippingId = jQuery(this).attr('name');
		var billingId = shippingId.replace('shipping_', 'billing_');

		console.log(data);
		console.log(billingId);

		jQuery('body').find('.billing-hidden select#' + billingId + ' option:selected').removeAttr('selected');
		jQuery('body').find('.billing-hidden select#' + billingId + ' option[value="' + data + '"]').attr('selected', 'selected');

		jQuery('select#' + billingId).select2();

	});


	jQuery('.product-type-variable .request_sample').click(function (e) {
		e.preventDefault();
		jQuery('.variations_form').submit();
	});

	jQuery('.main_nav a.search').click(function () {
		jQuery('.search_form').addClass('open');
	});

	jQuery('.search_form .bg, .search_form .close').click(function () {
		jQuery('.search_form').removeClass('open');
	});


	jQuery('.main_banner .down').click(function () {
		jQuery('html, body').animate({
			scrollTop: jQuery(this).parent().parent().next().offset().top - 140
	   	}, 300);
	});



	jQuery('#pa_color-group').change( function() {
		var prod_id = jQuery('form.variations_form').data('product_id');
		var variable = jQuery(this).val();
		var attr_name =jQuery(this).data('attribute_name');
		var sku_area = jQuery('.summary__list li.sku span')
		jQuery.ajax({
			url: my_ajax_object.ajax_url,
			data: {
				'action' : 'dynamically_change_sku',
				'prod_id' : prod_id,
				'variable' : variable,
				'attr_name' : attr_name
			},
			success: function(response) {
				sku_area.text(response);
			}
		});
	});

	// Shop loop: cycle variation images on thumbnail hover
	if ( window.matchMedia( '(hover: hover)' ).matches ) {
		var thumbInterval = 1200;
		var prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

		jQuery( '.product-thumb-stack.has-variation-images' ).each( function() {
			var $stack = jQuery( this );
			var $link = $stack.closest( '.woocommerce-loop-product__link' );
			var $primary = $stack.find( '.product-thumb-primary' );
			var $layerA = $stack.find( '.product-thumb-hover-a' );
			var $layerB = $stack.find( '.product-thumb-hover-b' );
			var $countCurrent = $link.find( '.product-thumb-count__current' );
			var images = [];
			var intervalId = null;
			var currentIndex = 0;
			var activeLayer = 'primary';
			var isHovered = false;

			try {
				images = JSON.parse( $stack.attr( 'data-variation-images' ) || '[]' );
			} catch ( e ) {
				images = [];
			}

			if ( ! images.length ) {
				return;
			}

			images.forEach( function( src ) {
				var img = new Image();
				img.src = src;
			} );

			function updateCount( index ) {
				if ( $countCurrent.length ) {
					$countCurrent.text( index + 1 );
				}
			}

			function getActiveLayer() {
				if ( activeLayer === 'a' ) {
					return $layerA;
				}
				if ( activeLayer === 'b' ) {
					return $layerB;
				}
				return $primary;
			}

			function getNextOverlay() {
				if ( activeLayer === 'a' ) {
					return $layerB;
				}
				return $layerA;
			}

			function crossfadeTo( index ) {
				updateCount( index );

				if ( index === 0 ) {
					$primary.css( { opacity: 1, zIndex: 2 } );
					$layerA.css( { opacity: 0, zIndex: 1 } );
					$layerB.css( { opacity: 0, zIndex: 1 } );
					activeLayer = 'primary';
					return;
				}

				var $current = getActiveLayer();
				var $next = activeLayer === 'primary' ? $layerA : getNextOverlay();

				$next.attr( 'src', images[ index ] ).css( { opacity: 1, zIndex: 2 } );
				$current.css( { opacity: 0, zIndex: 1 } );

				activeLayer = $next.is( $layerA ) ? 'a' : 'b';
			}

			function resetThumbnail() {
				$primary.css( { opacity: 1, zIndex: 1 } );
				$layerA.css( { opacity: 0, zIndex: 1 } );
				$layerB.css( { opacity: 0, zIndex: 1 } );
				currentIndex = 0;
				activeLayer = 'primary';
				updateCount( 0 );
			}

			function startCycle() {
				currentIndex = 0;
				activeLayer = 'primary';
				updateCount( 0 );

				if ( prefersReducedMotion || images.length < 2 ) {
					return;
				}

				// Featured image is already visible — advance straight to the first variation
				currentIndex = 1;
				crossfadeTo( currentIndex );

				intervalId = setInterval( function() {
					if ( ! isHovered ) {
						return;
					}

					currentIndex = ( currentIndex + 1 ) % images.length;
					crossfadeTo( currentIndex );
				}, thumbInterval );
			}

			function stopCycle() {
				clearInterval( intervalId );
				intervalId = null;
				resetThumbnail();
			}

			$link.on( 'mouseenter', function() {
				isHovered = true;
				startCycle();
			} ).on( 'mouseleave', function() {
				isHovered = false;
				stopCycle();
			} );
		} );
	}


});